import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useParams } from 'react-router-dom';
import '../styles/Lead.css';

function LeadContatti() {
  const { id } = useParams();
  const [contatti, setContatti] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [sort, setSort] = useState('nome');
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    richiesta: '',
    fonte: '',
    data_primo_contatto: ''
  });

  const fetchContatti = useCallback(async () => {
    const res = await api.get(`/lead-contatti/${id}`);
    setContatti(res.data);
  }, [id]);

  useEffect(() => {
    fetchContatti();
  }, [fetchContatti]);


  const sortedContatti = [...contatti].sort((a,b)=>{
    if(sort==='data_primo_contatto') return new Date(a.data_primo_contatto) - new Date(b.data_primo_contatto);
    return a.nome.localeCompare(b.nome);
  });

  const openForm = (c=null)=>{
    if(c){
      setFormData({
        ...c,
        data_primo_contatto: c.data_primo_contatto ? c.data_primo_contatto.split('T')[0] : ''
      });
      setEditing(c.id);
    }
    else {
      setFormData({nome:'',cognome:'',email:'',telefono:'',richiesta:'',fonte:'',data_primo_contatto:''});
      setEditing(null);
    }
    setShowForm(true);
  };

  const handleChange = e => setFormData({...formData,[e.target.name]:e.target.value});

  const handleSubmit = async (e)=>{
    e.preventDefault();
    const payload = {
      ...formData,
      data_primo_contatto: formData.data_primo_contatto || null,
      cantiere_id: id,
    };
    if(editing) await api.put(`/lead-contatti/${editing}`, payload);
    else await api.post(`/lead-contatti`, payload);
    setShowForm(false);
    fetchContatti();
  };

  const handleDelete = async (cid)=>{
    if(window.confirm('Eliminare questo contatto?')){
      await api.delete(`/lead-contatti/${cid}`);
      fetchContatti();
    }
  };

  return (
    <div className="sezione">
      <div className="sezione-title">
        <h2>Lead & Contatti</h2>
      </div>
      <div className="sezione-sort">
        <select className="sort-select" value={sort} onChange={e=>setSort(e.target.value)}>
          <option value="nome">Ordina per nome</option>
          <option value="data_primo_contatto">Ordina per data</option>
        </select>
        <button type="button" className="btn-aggiungi" onClick={()=>openForm()}>➕ Aggiungi Contatto</button>
      </div>
      {showForm && (
        <div className="modal-overlay">
          <div className="modal-contatti">
            <button type="button" className="close-button" onClick={() => setShowForm(false)}>✖</button>
            <form onSubmit={handleSubmit} className="form-contatto">
              <div className="form-grid-lead">
                <div className="form-group-lead">
                  <label htmlFor="Nome Contatto">Nome Contatto</label>
                  <input name="nome" placeholder="Nome" value={formData.nome} onChange={handleChange} required />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Cognome Contatto">Cognome Contatto</label>
                <input name="cognome" placeholder="Cognome" value={formData.cognome} onChange={handleChange} required />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Email Contatto">Email Contatto</label>
                  <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Telefono Contatto">Telefono Contatto</label>
                  <input type="tel" name="telefono" placeholder="Telefono" value={formData.telefono} onChange={handleChange} required />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Richiesta Contatto">Richieste</label>
                  <input name="richiesta" placeholder="Richiesta" value={formData.richiesta} onChange={handleChange} />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Fonte Contatto">Fonte Contatto</label>
                  <input name="fonte" placeholder="Fonte" value={formData.fonte} onChange={handleChange} />
                </div>
                <div className="form-group-lead">
                  <label htmlFor="Data Contatto">Data Contatto</label>
                  <input
                    type="date"
                    name="data_primo_contatto"
                    placeholder="Data primo contatto"
                    value={formData.data_primo_contatto}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-annulla" onClick={()=>setShowForm(false)}>Annulla</button>
                <button type="submit" className="btn-aggiungi">Salva</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <div className="card-container">
        {sortedContatti.map(c=> (
          <div className="card" key={c.id}>
            <div className="card-header">{c.nome} {c.cognome}
              <div>
                <button type="button" onClick={()=>openForm(c)}>✏️</button>
                <button type="button" onClick={()=>handleDelete(c.id)}>🗑️</button>
              </div>
            </div>
            <div className="card-body">
              <p><strong>Email:</strong> {c.email}</p>
              <p><strong>Telefono:</strong> {c.telefono}</p>
              <p><strong>Richiesta:</strong> {c.richiesta}</p>
              <p><strong>Fonte:</strong> {c.fonte}</p>
              <p><strong>Data primo contatto:</strong> {c.data_primo_contatto}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LeadContatti;

